var Tokens = {
  // Sequences that no-one will ever put in their keyboards.
  PIPE: '7440011c983cf39ae730b1f831e2922ac5a76910',
  OPEN_BRACE: 'f630c4abcae620278f82e142a526ef325c2a773a',
  CLOSE_BRACE: 'ad982c66898e02a5dab419ea7568421b03f68ee2'
};
export default {
  name: 'keyboard',
  props: {
    value: {
      type: String,
      "default": ''
    },
    layouts: {
      type: [String, Array],
      required: true
    },
    maxlength: {
      type: Number,
      "default": 0,
      validator: function validator(value) {
        return value >= 0;
      }
    },
    pattern: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      layout: 0
    };
  },
  computed: {
    /**
     * Whether or not the keyboard input has hit its maximum length.
     * @returns {Boolean}
     */
    full: function full() {
      return this.maxlength > 0 && this.value.length >= this.maxlength;
    },

    /**
     * Whether or not the keyboard input is empty.
     * @return {Boolean}
     */
    empty: function empty() {
      return this.value.length === 0;
    },

    /**
     * Returns the lines that make up a layout.
     * @return {Array}
     */
    lines: function lines() {
      var layout = (Array.isArray(this.layouts) ? this.layouts : [this.layouts])[this.layout];
      return layout.replace('||', Tokens.PIPE).replace('{{', Tokens.OPEN_BRACE).replace('}}', Tokens.CLOSE_BRACE).split('|');
    },

    /**
     * Returns an array of buttons to render in the component.
     * @returns {Array[]}
     */
    buttons: function buttons() {
      var _this = this;

      return this.lines.map(function (line) {
        // TODO: Could potentially rely on Object.values() here instead of being explicit.
        var stream = line.match(new RegExp("(".concat(Tokens.OPEN_BRACE, "|").concat(Tokens.CLOSE_BRACE, "|").concat(Tokens.PIPE, "|.)"), 'g'));
        var buttons = [];
        var token = null;
        stream.forEach(function (_char) {
          if (_char === '{') {
            token = '';
          } else if (_char === '}') {
            var command = token.split(':');
            var text = command.length > 1 ? command[0] : '';
            var action = command.length > 1 ? command[1] : command[0];
            var args = command.length > 2 ? command[2] : null;
            var method = null;
            if (['append', 'backspace', 'space', 'clear', 'goto'].indexOf(action) >= 0) method = _this[action].bind(_this, args);else method = _this.$emit.bind(_this, action, _this);
            buttons.push({
              type: 'action',
              action: {
                name: action.replace(/\s+/g, '-').toLowerCase(),
                callable: method
              },
              value: text,
              args: args
            });
            token = null;
          } else {
            if (token !== null) {
              token += _char;
            } else {
              if (_char === Tokens.PIPE) _char = '|';
              if (_char === Tokens.OPEN_BRACE) _char = '{';
              if (_char === Tokens.CLOSE_BRACE) _char = '}';
              buttons.push({
                type: 'char',
                action: {
                  name: null,
                  callable: _this.append.bind(_this, _char)
                },
                value: _char,
                args: null
              });
            }
          }
        });
        return buttons;
      });
    },

    /**
     * Whether or not the current value matches the regex provided to pattern. Always
     * returns true if no pattern was provided.
     * @returns {Boolean}
     */
    valid: function valid() {
      return !this.pattern || this.value.match(new RegExp(this.pattern));
    }
  },
  methods: {
    /**
     * Mutates the keyboard value to a new value.
     * @param {String} value The new value.
     */
    mutate: function mutate(value) {
      if (this.maxlength > 0) {
        value = value.slice(0, this.maxlength);
      }

      this.$emit('input', value);
    },

    /**
     * Appends a new value to the end of the current keyboard value.
     * @param {String} char The character(s) to append.
     */
    append: function append(_char2) {
      this.mutate(this.value + _char2);
    },

    /**
     * Remove the last character from the current keyboard value.
     */
    backspace: function backspace() {
      this.mutate(this.value.slice(0, this.value.length - 1));
    },

    /**
     * Add one whitespace character to the current keyboard value.
     */
    space: function space() {
      this.append(' ');
    },

    /**
     * Go to a new layout.
     * @param {Number} The layout index.
     */
    "goto": function _goto(layout) {
      if (Array.isArray(this.layouts)) {
        if (layout >= 0 && layout < this.layouts.length) {
          this.layout = layout;
        } else {
          throw new Error('The requested layout does not exist.');
        }
      } else {
        throw new Error('A single non-array layout was provided.');
      }
    },

    /**
     * Clear the entire keyboard value.
     */
    clear: function clear() {
      this.mutate('');
    }
  }
};